import { Link, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { ResetPasswordForm } from '@/components/auth/reset-password-form';

export const Route = createFileRoute('/_auth/reset-password')({
  validateSearch: (search: Record<string, unknown>): { token: string } => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: ResetPasswordPage,
});

function ResetPasswordPage(): React.ReactElement {
  const { token } = Route.useSearch();
  return (
    <section className="border-border bg-card rounded-2xl border p-8 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
      <h1 className="font-display text-2xl tracking-tight">Nouveau mot de passe</h1>
      <p className="text-muted-foreground mt-2 text-sm">
        Choisissez un nouveau mot de passe sécurisé.
      </p>
      <div className="mt-8">
        <ResetPasswordForm token={token} />
      </div>
      <p className="text-muted-foreground mt-6 text-center text-sm">
        <Link to="/sign-in" className="text-primary font-medium hover:underline">
          Retour à la connexion
        </Link>
      </p>
    </section>
  );
}
